//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "pages-header",
    props: ["titleName", "btnName", "btnImg", "backImg", "navList", "returnBack"],
    data() {
        return {
            toBackImg: require("@/assets/image/toback.png"), //返回图标
            defaultBackImg: "", //背景图片
            active: 0 //导航当前选择
        };
    },
    mounted() {
        if (this.backImg) {
            this.$refs["pagesHeaderType"].style.color = "#333";
            // this.$refs["pagesHeaderType"].style.borderBottom = "1px solid #DDD";
            this.$refs["pagesHeaderType"].style.boxShadow = "0 0.02rem 0.04rem 0 rgba(0,0,0,0.05)";
            this.toBackImg = require("@/assets/image/toback1.png");
            this.defaultBackImg = this.backImg;
        }
        if (this.navList) {
            for (let i = 0; i < this.$refs["navLi"].length; i++) {
                this.$refs["navLi"][i].style.width =
                    parseInt(100 / this.navList.length) + "%";
            }
        }
    },
    methods: {
        //返回按钮回调
        returnBackFn() {
            if(this.$route.query.go){
                this.$router.push({path:'/homeIndex'});
                return;
            }
            this.returnBack ? this.returnBack() : this.$router.go(-1);
        },
        //按钮回调
        btnBackFn() {
            this.$emit("btnBack");
        },
        //导航回调
        toReturn(i, id) {
            this.active = i;
            this.$emit("navBack", id);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/pages-header.vue